import React, { useState } from "react";
import PropTypes from "prop-types";

interface IdGisHierarchiContextModel {
  idGishierarchi: number;
  setIdGishierarchiState: ( idGishierarchi : number ) => void;
  itemsGishierarchi: object;
  setItemsGishierarchiState: ( itemsGishierarchi : object ) => void;
}

export const IdGisHierarchiContext = React.createContext<IdGisHierarchiContextModel>({
  idGishierarchi: 0,
  setIdGishierarchiState: () => console.log(),
  itemsGishierarchi: {},
  setItemsGishierarchiState: () => console.log(),
});


const IdGisHierarchiProvider: React.FC = (props) => {

  const [idGishierarchi, setIdGishierarchi] = useState<number>(0);
  const [itemsGishierarchi, setItemsGishierarchi] = useState<object>({});


  const setIdGishierarchiState = (id: number )=> {
    setIdGishierarchi(id);
  }
  const setItemsGishierarchiState = (items: object )=> {
    setItemsGishierarchi(items);
  }

  const idGisHierarchiContext = {
    idGishierarchi,
    setIdGishierarchiState,
    itemsGishierarchi,
    setItemsGishierarchiState,
  }

  return (
    <IdGisHierarchiContext.Provider value={idGisHierarchiContext}>
      {props.children}
    </IdGisHierarchiContext.Provider>
  );

};

IdGisHierarchiProvider.propTypes = {
  children: PropTypes.node,
};


export default IdGisHierarchiProvider;



